import { useEffect } from "react";
import { useRealtimeStore } from "../../lib/store.js";

const AUTO_DISMISS_MS = 6000;

export const BotCallbackToasts = () => {
  const toasts = useRealtimeStore((state) => state.botCallbackToasts);
  const dismiss = useRealtimeStore((state) => state.dismissBotCallbackToast);

  useEffect(() => {
    if (toasts.length === 0) {
      return;
    }
    const handles = toasts
      .filter((toast) => !toast.showAlert)
      .map((toast) => window.setTimeout(() => dismiss(toast.id), AUTO_DISMISS_MS));
    return () => {
      for (const handle of handles) {
        window.clearTimeout(handle);
      }
    };
  }, [dismiss, toasts]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="bot-toasts" role="region" aria-label="Ответы ботов">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={
            toast.showAlert ? "bot-toasts__item bot-toasts__item--alert" : "bot-toasts__item"
          }
          role={toast.showAlert ? "alertdialog" : "status"}
        >
          <div className="bot-toasts__text">{toast.text}</div>
          {toast.url ? (
            <a
              href={toast.url}
              target="_blank"
              rel="noreferrer noopener"
              className="bot-toasts__link"
            >
              Открыть ссылку
            </a>
          ) : null}
          <button
            type="button"
            className="bot-toasts__dismiss"
            onClick={() => dismiss(toast.id)}
            aria-label="Закрыть"
          >
            <i className="ic ic-close" aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
};
